import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { mainColors, lpPageColors } from 'src/assets/colors';
import { fontSize, fontWeight } from 'src/assets/fonts-config';
import { EmailIcon } from 'src/assets/icons/EmailIcon';
import { FacebookIcon } from 'src/assets/icons/FacebookIcon';
import { InstagramIcon } from 'src/assets/icons/InstagramIcon';
import { PhoneIcon } from 'src/assets/icons/PhoneIcon';
import { TwitterIcon } from 'src/assets/icons/TwitterIcon';
import { mediaQuery } from 'src/assets/media-query-config';
import { Button } from 'src/domains/layouts/shared/buttons/Button';
import { ButtonsWrapper } from 'src/domains/layouts/shared/buttons/Button.style';

export const ContactUsListWrapper = styled('div', { label: 'ContactUsListWrapper' })`
    width: 100%;
    @media ${mediaQuery.xxxxLargeDesktop} {
        display: flex;
        flex-flow: column nowrap;
        max-width: 1650px;
        flex-flow: row nowrap;
    }
`;

export const EditElementsWrapper = styled('div', { label: 'EditElementsWrapper' })`
    flex: 1 1 0;
    max-width: 100%;

    @media ${mediaQuery.xxxxLargeDesktop} {
        flex: 1 0 60%;
        max-width: 60%;
        margin-right: 32px;
    }
`;

export const AddElementsWrapper = styled('div', { label: 'AddElementsWrapper' })`
    flex: 1 0 100%;
    max-width: 100%;

    @media ${mediaQuery.xxxxLargeDesktop} {
        flex: 1 0 40%;
        max-width: 40%;
    }
`;

type FormWrapperPropsType = {
    extraMarginBottom?: boolean;
};

export const FormWrapper = styled('div', { label: 'FormWrapper' })<FormWrapperPropsType>`
    display: grid;
    grid-template-columns: auto 80px;
    ${({ extraMarginBottom }): string => (extraMarginBottom === true ? 'margin-bottom: 16px' : '')}
`;

export const FooterContactUsElementEditForm = styled.form`
    display: grid;
    width: 100%;
    grid-gap: 16px;
    grid-auto-flow: column;
    grid-template-columns: 24px repeat(2, 5fr) 5fr;
    div {
        margin-bottom: 0;
    }
`;
export const FooterContactUsElementCreateForm = styled.form`
    display: grid;
    width: 100%;
    grid-gap: 16px;
    grid-auto-flow: column;
    grid-template-columns: 24px repeat(2, 5fr) 5fr;
    @media ${mediaQuery.xxxxLargeDesktop} {
        grid-template-columns: 24px repeat(2, 5fr);
    }
    div {
        margin-bottom: 0;
    }
`;

export const InputWrapper = styled('div', { label: 'InputWrapper' })`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;

    > div:nth-of-type(1) {
        flex: 0 0 300px;
        margin-right: 8px;
    }
`;

export const ActionButtonsWrapper = styled(ButtonsWrapper, { label: 'ActionButtonsWrapper' })`
    margin-left: 16px;
    gap: 16px;
    padding-top: 22px;
    button:not(:first-of-type) {
        margin: 0;
    }
`;

export const ButtonWrapper = styled(Button, { label: 'ButtonWrapper' })`
    height: 32px;
`;

export const ActiveLabel = styled('span', { label: 'ActiveLabel' })`
    color: ${lpPageColors.activeLabel};
    font-size: ${fontSize.small};
    font-weight: ${fontWeight.bold};
    line-height: 1.3334;
    margin-left: 8px;
`;

export const ControlsContainer = styled('div', { label: 'ControlsContainer' })`
    display: flex;
    flex-flow: row nowrap;
    padding-top: 22px;

    > div:first-of-type {
        flex: 0 0 100px;
    }
`;

const setIcon = (): SerializedStyles => {
    return css`
        display: block;
        fill: currentcolor;
        flex: 0 0 24px;
        margin: 28px 8px 0 0;
        width: 24px;
    `;
};

export const IconTwitterWrapper = styled(TwitterIcon, { label: 'IconTwitterWrapper' })`
    ${setIcon};
`;

export const IconEmailWrapper = styled(EmailIcon, { label: 'IconEmailWrapper' })`
    ${setIcon};
`;

export const IconPhoneWrapper = styled(PhoneIcon, { label: 'IconPhoneWrapper' })`
    ${setIcon};
`;

export const IconFacebookWrapper = styled(FacebookIcon, { label: 'IconFacebookWrapper' })`
    ${setIcon};
`;

export const IconInstagramWrapper = styled(InstagramIcon, { label: 'IconInstagramWrapper' })`
    ${setIcon};
`;

export const InputRowSeparator = styled('hr', { label: 'InputRowSeparator' })`
    background: ${mainColors.grays.gray200};
    border: none;
    display: block;
    height: 1px;
    margin: 16px 0;
    &:last-of-type {
        display: none;
    }
`;
